import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { getLanguageIcon } from 'Helpers/LanguageHelper';
import RichText from 'vcomponents/richtext/RichText.vue';
import { inject, ref } from 'vue';
import { Language } from 'js/vue/stores/languages/languagesStore';
import type { TranslatableText } from 'types/api/settings/invoicing/invoicingConditionsTypes';
import { Translator } from 'js/shims-vue';
import Heading from 'vcomponents/common/Heading/Heading.vue';
import { useTranslatableText } from 'composables/useTranslatableText';

interface Props {
    languages: Language[];
    title: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InvoiceTermsEditor',
  props: /*@__PURE__*/_mergeModels({
    languages: {},
    title: {}
  }, {
    "modelValue": {
    default: (): TranslatableText => ({ value: '', translations: [] }),
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const translatableText = _useModel<TranslatableText>(__props, "modelValue");

const { getTranslationValue, updateTranslationValue, updateDefaultValue } =
    useTranslatableText(translatableText);

const $t = inject('$t') as Translator;

const currentTab = ref<string>('default');

const optionsRichText: string[] = ['Bold', 'Italic', 'TextAlign', 'BulletList', 'CodeBlock'];

return (_ctx: any,_cache: any) => {
  const _component_CompassTabPane = _resolveComponent("CompassTabPane")!
  const _component_CompassTabs = _resolveComponent("CompassTabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Heading, {
      labelTitle: __props.title,
      variant: "h3"
    }, null, 8 /* PROPS */, ["labelTitle"]),
    _createVNode(_component_CompassTabs, {
      modelValue: currentTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTabPane, {
          label: _unref($t).__('common.labels.by_default'),
          name: "default",
          icon: "flag-fill"
        }, {
          default: _withCtx(() => [
            _createVNode(RichText, {
              modelValue: translatableText.value.value,
              options: optionsRichText,
              "onUpdate:modelValue": _unref(updateDefaultValue)
            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.languages, (language) => {
          return (_openBlock(), _createBlock(_component_CompassTabPane, {
            key: language.id,
            label: language.lang,
            name: language.lang,
            customIcon: _unref(getLanguageIcon)(language)
          }, {
            default: _withCtx(() => [
              _createVNode(RichText, {
                modelValue: _unref(getTranslationValue)(language.id),
                options: optionsRichText,
                "onUpdate:modelValue": ($event: any) => (_unref(updateTranslationValue)(language.id, $event))
              }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "name", "customIcon"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})